import { Globe, Languages, Sparkles } from "lucide-react";
import { Card, SecretField, SettingsForm, useSettings } from "./shared";

export default function ApiKeysSection() {
  const { form, handleChange } = useSettings();

  return (
    <SettingsForm>
      <Card icon={Sparkles} title="Article AI (OpenAI)" subtitle="For Article Rewrite, outline gap analysis and the editor's AI tools">
        <SecretField label="OpenAI API Key" optional name="openai_api_key" value={form.openai_api_key} onChange={handleChange}
          placeholder="sk-… — leave blank to use the built-in key" />
        <div className="text-[10px] text-zinc-400 space-y-0.5">
          <p>Optional. Powers <span className="font-semibold text-zinc-600">Improve Article</span>, <span className="font-semibold text-zinc-600">Find coverage gaps</span>, and the editor's AI menu and autocomplete.</p>
          <p>Leave blank to use the platform's built-in OpenAI key. Add your own at <span className="font-mono">platform.openai.com</span> to bill these calls to your account.</p>
        </div>
      </Card>

      <Card icon={Globe} title="Search API" subtitle="For competitor schema analysis">
        <SecretField label="Serper.dev API Key" optional name="serper_api_key" value={form.serper_api_key} onChange={handleChange}
          placeholder="serper.dev key — leave blank to use built-in search" />
        <div className="text-[10px] text-zinc-400 space-y-0.5">
          <p>Optional. Search is built in — add your own <span className="font-semibold text-zinc-600">Serper.dev</span> key only if you want searches billed to your Serper account.</p>
          <p>Get a key at <span className="font-mono">serper.dev</span> — 2,500 free searches on sign-up.</p>
        </div>
      </Card>

      <Card icon={Languages} title="Translation API" subtitle="For multilingual article generation">
        <SecretField label="DeepL API Key" optional name="deepl_api_key" value={form.deepl_api_key} onChange={handleChange}
          placeholder="DeepL API key — free or pro tier" />
        <div className="text-[10px] text-zinc-400 space-y-0.5">
          <p>Free-tier keys end with <span className="font-mono">:fx</span> — auto-detected. Get a key at <span className="font-mono">deepl.com/pro</span>.</p>
          <p>Used by the Translate button on each article to produce multilingual drafts.</p>
        </div>
      </Card>
    </SettingsForm>
  );
}
